<template>
  <ul
    v-show="visible"
    class="s-select-group__wrap"
    :is-active="visible">
    <li class="s-select-group__title">
      {{ label }}
    </li>
    <li>
      <ul class="s-select-group">
        <slot/>
      </ul>
    </li>
  </ul>
</template>

<script>
import emitter from '../../mixins/emitter'

/**
 * Стандартный Select Grouping
 * @displayName Select Grouping
 */

export default {
  mixins: [emitter],
  name: 'sOptionGroup',
  componentName: 'sOptionGroup',
  props: {
    /**
     * название группы
     */
    label: String,
    /**
     * следует ли отключить все параметры в этой группе
     */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: true
    }
  },
  watch: {
    disabled(val) {
      this.broadcast('sOption', 'handleGroupDisabled', val)
    }
  },
  methods: {
    queryChange() {
      this.visible = this.$children &&
          Array.isArray(this.$children) &&
          this.$children.some(option => option.visible === true)
    }
  },
  created() {
    this.$on('queryChange', this.queryChange)
  },
  mounted() {
    if (this.disabled) {
      this.broadcast('sOption', 'handleGroupDisabled', this.disabled)
    }
  }
}
</script>